import { render, staticRenderFns } from "./ShiftEditDialog.vue?vue&type=template&id=079efc43&scoped=true&lang=pug&"
import script from "./ShiftEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditDialog.vue?vue&type=style&index=0&id=079efc43&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079efc43",
  null
  
)

export default component.exports